import * as Yup from 'yup';

import { Enums, UserEnums } from '@project44-models/iam-gateway';

import { YupValidator } from '../../../../shared/core/domain/YupValidator';
import { IUserFormCreator } from '../interfaces';

export const userCreationSchema = YupValidator.composeValidatorSchema<{
  [K in keyof IUserFormCreator]: Yup.AnySchema<IUserFormCreator[K]>;
}>([
  {
    familyName: YupValidator.validateNonEmptyString()
      .default('')
      .required('Family Name is required'),
    givenName: YupValidator.validateNonEmptyString()
      .default('')
      .required('Given Name is required'),
    username: YupValidator.validateEmail('Email')
      .default('')
      .trim()
      .required('Email is required'),
    password: Yup.string()
      .default('')
      .when('password', {
        is: (value: string) => !!value?.length,
        then: YupValidator.validateUserPassword().required(),
        otherwise: Yup.string().optional(),
      }),
    phoneNumber: Yup.string().trim().default('').optional(),
    userType: Yup.mixed<UserEnums.UserTypeEnum>()
      .default(UserEnums.UserTypeEnum.USER)
      .oneOf(Object.values(UserEnums.UserTypeEnum))
      .required('This field is required'),
    isAdmin: YupValidator.validateEnum(Enums.BooleanAsStringEnum)
      .default(Enums.BooleanAsStringEnum.FALSE)
      .required(),
  },
  ['userType', 'password'],
]);
